module.exports = __webpack_public_path__ + "static/crater-lake-a39371718b09d931fd1b22179ddfd45b.jpg";